// Photo-led card rows (home use cases, truck owner cards): arrows (desktop), progress bar, and the rest of the photos
// on the first move. The visitor moves the row; the page never takes over the scroll.
const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

document.querySelectorAll('[data-swipe-track]').forEach((track) => {
  const section = track.closest('section');
  const prev = section.querySelector('[data-swipe="-1"]');
  const next = section.querySelector('[data-swipe="1"]');
  const bar = section.querySelector('[data-swipe-bar]');
  let loaded = false;
  const loadAll = () => {
    if (loaded) return;
    loaded = true;
    track.querySelectorAll('img[data-lazy]').forEach((img) => { if (img.dataset.srcset) img.srcset = img.dataset.srcset; if (img.dataset.src) img.src = img.dataset.src; img.removeAttribute('data-lazy'); });
  };
  const update = () => {
    const max = track.scrollWidth - track.clientWidth;
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max - 2;
    if (bar) {
      const w = max > 0 ? track.clientWidth / track.scrollWidth : 1;
      bar.style.width = `${w * 100}%`;
      bar.style.transform = `translateX(${max > 0 ? (track.scrollLeft / max) * (1 / w - 1) * 100 : 0}%)`;
    }
  };
  section.querySelector('[data-swipe-controls]')?.addEventListener('click', (e) => {
    const b = e.target.closest('[data-swipe]');
    if (!b) return;
    loadAll();
    const card = track.firstElementChild;
    const step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth;
    track.scrollBy({ left: Number(b.dataset.swipe) * step, behavior: reduced ? 'auto' : 'smooth' });
  });
  track.addEventListener('scroll', () => { loadAll(); requestAnimationFrame(update); }, { passive: true });
  addEventListener('resize', update);
  update();
});

